@if (isLoading) {
  <div class="xi-loader-container__center">
    <xi-animation [loop]="true" animation="cx_loader"></xi-animation>
  </div>
}

<ng-container *transloco="let t">
  @if (dataSourceNotFound && !isLoading) {
    <div class="crosstab__error-wrapper">
      <div class="text-center">
        <h1>{{ t('widgets.data-source-removed-select-another') }}</h1>
      </div>
    </div>
  }
  @if (noData && !isLoading) {
    <div class="crosstab__error-wrapper">
      <h1>
        {{ t('widgets.no-data-found') }}
      </h1>
    </div>
  }
  @if (noPermission) {
    <div class="crosstab__error-wrapper">
      <h1>{{ t('widgets.no-permission-to-view') }}</h1>
    </div>
  }
  @if (hasInvalidComparison && !isLoading) {
    <div class="crosstab__error-wrapper">
      <h1>
        <h1>{{ t('widgets.has-invalid-comparison') }}</h1>
      </h1>
    </div>
  }
  @if (!dataSourceNotFound && !noData && !hasInvalidComparison && !noPermission) {
    @if (!isDependencyWheel && !isLoading && !dataSourceNotFound) {
      <div
        #tableWrapper
        class="crosstab__table-wrapper"
        [class.crosstab__table-wrapper--customSort]="isCustomSortMode"
        cdkDropList
        [cdkDropListOrientation]="'vertical'"
        (cdkDropListDropped)="onRowReordered($event)"
        cdkScrollable
      >
        @if (isCustomSortMode) {
          <div
            #columnDropList
            cdkDropList
            [cdkDropListOrientation]="'horizontal'"
            (cdkDropListDropped)="onColumnReordered($event)"
            class="crosstab__column-reorder-helper mat-mdc-table"
          >
            @for (column of dataSource.displayedColumns; track column; let i = $index) {
              @if (i === 0) {
                <div #fakeTableSplitter></div>
              } @else {
                <div
                  cdkDrag
                  cdkDragLockAxis="x"
                  cdkDragBoundary=".crosstab__column-reorder-helper"
                  [cdkDragDisabled]="i === 0"
                  cdkDragPreviewContainer="parent"
                  class="mat-mdc-header-cell mdc-data-table__header-cell"
                  [class.crosstab__table-header-cell]="i !== 0"
                  [class.crosstab__table-header-cell--date]="isColumnDate"
                >
                  <div
                    class="crosstab__table-header-cell-wrapper crosstab__table-header-cell-wrapper--customSort"
                  >
                    <span class="crosstab__table-header-cell-text">{{
                      formatHeader(column, 'column', true)
                    }}</span>
                    <xi-icon buttonSize="small" icon="width" contrast="high"></xi-icon>
                  </div>
                </div>
              }
            }
          </div>
        }
        <table
          mat-table
          [dataSource]="dataSource"
          class="crosstab__table"
          [class.crosstab__table--insight-point-selection]="insightPointSelectionState.active"
        >
          @for (column of dataSource.displayedColumns; track column; let i = $index) {
            <ng-container [matColumnDef]="dataSource.generateColumnId(column)" [sticky]="i === 0">
              <th
                mat-header-cell
                *matHeaderCellDef
                [class.crosstab__table-header-cell]="i !== 0"
                [ngClass]="{ 'overflow-visible': i !== 0, splitter: i === 0 }"
                [class.crosstab__table-header-cell--date]="isColumnDate"
                (click)="i !== 0 && openCellMenu($event, undefined, column, 'column')"
              >
                @if (i === 0) {
                  <div #tableSplitter style="visibility: hidden">
                    <div
                      class="crosstab__table-header-splitter crosstab__table-header-splitter--column"
                      [matTooltip]="headerSplitterTooltip(widget.payload.columnAnalyticItem)"
                    >
                      {{ longFieldName(widget.payload.columnAnalyticItem) }}
                    </div>
                    <div
                      class="crosstab__table-header-splitter crosstab__table-header-splitter--row"
                      [matTooltip]="headerSplitterTooltip(widget.payload.analyticItem)"
                    >
                      {{ longFieldName(widget.payload.analyticItem) }}
                    </div>
                  </div>
                } @else {
                  @if (getCellComments(undefined, column); as cellComments) {
                    <ng-container
                      *ngTemplateOutlet="
                        commentIcon;
                        context: { comments: cellComments, column, extraData: 'column' }
                      "
                    ></ng-container>
                  }
                  <div
                    class="crosstab__table-header-cell-wrapper"
                    [class.crosstab__table-header-cell-wrapper--customSort]="isCustomSortMode"
                    [class.crosstab__table-header-cell-wrapper--currentSort]="
                      isSortedBy('columnSort', column)
                    "
                  >
                    <span
                      [matTooltip]="formatHeader(column, 'column')"
                      class="crosstab__table-header-cell-text"
                      >{{ formatHeader(column, 'column', true) }}</span
                    >
                    @if (!isCustomSortMode) {
                      <div class="crosstab__sort-icon">
                        <xi-icon-button
                          buttonSize="small"
                          (onClick)="sortChartItems($event, 'columnSort', column)"
                          [icon]="getSortIcon('columnSort', column)"
                          contrast="high"
                        ></xi-icon-button>
                      </div>
                    }
                    @if (isCustomSortMode) {
                      <div>
                        <xi-icon buttonSize="small" icon="width" contrast="high"></xi-icon>
                      </div>
                    }
                  </div>
                }
              </th>
              <td
                mat-cell
                *matCellDef="let element"
                (mousedown)="toggleRowDraggable(i, true, $event)"
                (mouseup)="toggleRowDraggable(i, false, $event)"
                [ngClass]="i !== 0 && getCellClass(element[column])"
                [class.crosstab__table-header-cell]="i === 0"
                [class.crosstab__table-header-cell--date]="i === 0 && isRowDate"
                [class.crosstab__table-cell--self-occurence]="
                  isSingleItem && element[key] === column
                "
                [class.crosstab__table-cell--no-heatmap]="!payload.display.heatmap"
                [class.elevated]="i === 0"
                [class.overflow-visible]="
                  hasCellPinnedComment(element[key], column) ||
                  selectedInsightPoints().includes(element[key] + rowColumnSeparator + column)
                "
                [attr.data-z-index]="i !== 0 && !getCellComments(element[key]) ? 1 : 2"
                (click)="openCellMenu($event, element, column, i === 0 ? 'row' : undefined)"
              >
                @if (i !== 0) {
                  @let cellComments = getCellComments(element[key], column);
                  <span [matTooltip]="getTooltipDisplay(element[column])">
                    @if (displayAsPercentage) {
                      {{ element[column] | percent: percentageDecimals }}
                    } @else {
                      {{ formatCellNumber(element[column]) }}
                    }
                  </span>
                  @if (cellComments) {
                    <ng-container
                      *ngTemplateOutlet="
                        commentIcon;
                        context: { comments: cellComments, row: element, column }
                      "
                    ></ng-container>
                  }

                  @if (
                    selectedInsightPoints().includes(element[key] + rowColumnSeparator + column)
                  ) {
                    <ng-container
                      *ngTemplateOutlet="insightPoint; context: { element, column }"
                    ></ng-container>
                  }
                } @else {
                  @if (getCellComments(element[key]); as cellComments) {
                    <ng-container
                      *ngTemplateOutlet="
                        commentIcon;
                        context: { comments: cellComments, row: element, column, extraData: 'row' }
                      "
                    ></ng-container>
                  }
                  <div
                    class="crosstab__table-header-cell-wrapper"
                    [class.crosstab__table-header-cell-wrapper--customSort]="isCustomSortMode"
                    [class.crosstab__table-header-cell-wrapper--currentSort]="
                      isSortedBy('sort', element[column])
                    "
                  >
                    <span
                      [matTooltip]="formatHeader(element[column], 'row')"
                      class="crosstab__table-header-cell-text"
                    >
                      {{ formatHeader(element[column], 'row', true) }}
                    </span>
                    @if (!isCustomSortMode) {
                      <div class="crosstab__sort-icon">
                        <xi-icon-button
                          buttonSize="small"
                          (onClick)="sortChartItems($event, 'sort', element[column])"
                          [icon]="getSortIcon('sort', element[column])"
                          contrast="high"
                        ></xi-icon-button>
                      </div>
                    }
                    <xi-icon
                      buttonSize="small"
                      icon="sort"
                      contrast="high"
                      class="crosstab__sort-icon crosstab__sort-icon--custom"
                    ></xi-icon>
                  </div>
                }
              </td>
            </ng-container>
          }
          <tr mat-header-row *matHeaderRowDef="dataSource.displayedColumnIds; sticky: false"></tr>
          <tr
            mat-row
            *matRowDef="let row; columns: dataSource.displayedColumnIds"
            cdkDrag
            cdkDragLockAxis="y"
            [cdkDragDisabled]="!isCustomSortMode || !isRowDraggable || disablePinnedCommentClick"
            cdkDragPreviewContainer="parent"
            [cdkDragData]="row"
          ></tr>
        </table>
        <ng-template
          #commentIcon
          let-comments="comments"
          let-row="row"
          let-column="column"
          let-extraData="extraData"
        >
          @if (getPinnedComment(comments); as pinnedComment) {
            <div
              class="pinned-comment-container"
              appPinnedCommentDrag
              [(comment)]="pinnedComment"
              containerClass="crosstab__table"
              (isDragging)="disablePinnedCommentClick = $event"
              (click)="onCellCommentIconClicked($event, row, column, extraData)"
            >
              <app-comment-compact-card
                #commentCard
                [comment]="pinnedComment"
                [selected]="selectedCommentPointId === pinnedComment.target.pointId"
              ></app-comment-compact-card>
            </div>
          } @else {
            <xi-icon
              icon="comment_filled"
              class="crosstab__table-cell--comment-icon"
              [class.selected]="selectedCommentPointId === comments[0].target.pointId"
              (click)="onCellCommentIconClicked($event, row, column, extraData)"
            ></xi-icon>
          }
        </ng-template>
      </div>
    }
    @if (isDependencyWheel) {
      <div #elementContent class="crosstab__chart" [class.hide]="isLoading"></div>
    }
    <div
      [matMenuTriggerFor]="crosstabMenuTrigger"
      #menuTriggerElement="matMenuTrigger"
      class="context-menu-trigger"
    ></div>
  }

  <ng-template #insightPoint let-element="element" let-column="column">
    <div class="crosstab__insight-point-markup">
      <xi-icon icon="lightbulb" iconSize="small" color="CX"></xi-icon>

      <span>{{
        selectedInsightPoints().indexOf(element[key] + rowColumnSeparator + column) + 1
      }}</span>
    </div>
  </ng-template>

  <mat-menu #crosstabMenuTrigger class="menu-with-xi-icons" xPosition="before">
    <ng-template
      matMenuContent
      let-item="item"
      let-row="row"
      let-column="column"
      let-axis="axis"
      let-axisItems="axisItems"
      let-customSet="customSet"
    >
      <div mat-menu-item disabled>
        {{ formatHeader(item, axis) | truncate: 15 : '…' }}
        @if (!axis) {
          <span> × {{ formatHeader(column, 'column') | truncate: 15 : '…' }} </span>
        }
      </div>

      <button
        mat-menu-item
        (click)="showDocuments(item, column, axis, axisItems)"
        [disabled]="!pointHasDocuments"
      >
        <xi-icon [color]="!pointHasDocuments ? 'disabled' : 'orca'" icon="preview"></xi-icon>
        <div>{{ t('widgets.show-documents') }}</div>
      </button>

      @if (isSmartSummaryEnabled && !isReadOnly) {
        <div [matTooltip]="interactiveSmartSummaryMenu.tooltip">
          <button
            mat-menu-item
            (click)="openCrosstabSmartSummary(item, column, axis, axisItems)"
            [disabled]="!interactiveSmartSummaryMenu.enabled"
          >
            <xi-icon
              [color]="!interactiveSmartSummaryMenu.enabled ? 'disabled' : 'orca'"
              icon="lightbulb"
            ></xi-icon>
            <div>{{ interactiveSmartSummaryMenu.label }}</div>
          </button>
        </div>
      }
      @if (isSmartSummaryEnabled && !isReadOnly && pointSummaries?.length > 0) {
        <div [matTooltip]="removeInteractiveSmartSummaryMenu.tooltip">
          <button
            mat-menu-item
            (click)="removeSmartSummary()"
            [disabled]="!removeInteractiveSmartSummaryMenu.enabled"
          >
            <xi-icon
              [color]="!removeInteractiveSmartSummaryMenu.enabled ? 'disabled' : 'orca'"
              icon="indeterminate"
            ></xi-icon>
            <div>{{ removeInteractiveSmartSummaryMenu.label }}</div>
          </button>
        </div>
      }
      @if (isSmartSummaryEnabled && !isReadOnly) {
        <div [matTooltip]="downloadSmartSummaryRequestToolTip">
          <button
            mat-menu-item
            (click)="downloadSmartSummarySpotERequest(item, column, axis, axisItems)"
            [disabled]="downloadingSpoteRequest || !canCreateSmartSummary"
          >
            <xi-icon
              [color]="downloadingSpoteRequest || !canCreateSmartSummary ? 'disabled' : 'orca'"
              icon="download"
            ></xi-icon>
            <div>{{ t('widgets.smart-summary.download-smart-summary-spote-request') }}</div>
          </button>
        </div>
      }
      @if (canAddComment) {
        <div [matTooltip]="commentDialogTooltip()">
          <button
            mat-menu-item
            [disabled]="!canOpenCommentDialog"
            [matMenuTriggerFor]="commentsMenuTrigger"
          >
            <xi-icon [color]="!canOpenCommentDialog ? 'disabled' : 'orca'" icon="comment"></xi-icon>
            <div>{{ t('widgets.comments.comments') }}</div>
          </button>

          <mat-menu #commentsMenuTrigger class="menu-with-xi-icons" xPosition="after">
            <div [matTooltip]="addCommentDialogToolTip()">
              @if (!isReadOnly) {
                <div>
                  <button mat-menu-item (click)="openCommentDialog()">
                    <xi-icon icon="add_circle"></xi-icon>
                    <div>{{ t('widgets.comments.label-add') }}</div>
                  </button>
                </div>
              }
            </div>
            <div [matTooltip]="openCommentDialogToolTip({ item, row, column, axis })">
              <button
                mat-menu-item
                [disabled]="!hasComment({ item, row, column, axis })"
                (click)="onCommentListOpenClicked(itemClicked)"
              >
                <xi-icon icon="app_explore"></xi-icon>
                <div>{{ t('widgets.comments.label-open') }}</div>
              </button>
            </div>
          </mat-menu>
        </div>
      }
      @if (axis && !customSet && !dashboard.locked) {
        <div [matTooltip]="showHideItemToolTip(axis)">
          <button
            mat-menu-item
            (click)="hideCrosstabItem(item, axis)"
            [disabled]="!enableHideItemsOnAxis(axis)"
          >
            <xi-icon
              [color]="!enableHideItemsOnAxis(axis) ? 'disabled' : 'orca'"
              icon="remove_circle"
            ></xi-icon>
            <div>{{ hideItemLabel }}</div>
          </button>
        </div>
      }
    </ng-template>
  </mat-menu>

  @if (isCustomSortMode) {
    <div class="crosstab__sort-save-bar">
      <div class="crosstab__sort-save-bar-actions">
        <xi-default-button
          [text]="t('widgets.cancel')"
          fill="text"
          (onClick)="finishCustomSort()"
        ></xi-default-button>
        <xi-default-button
          [text]="t('widgets.save')"
          (onClick)="finishCustomSort(true)"
        ></xi-default-button>
      </div>
    </div>
  }
  @if (showDocumentViewModal) {
    <app-lex-xi-modal
      [isVisible]="showDocumentViewModal"
      [canBackdropClose]="false"
      maxWidth="80vw"
      (close)="onDocumentViewModalClosed($event)"
    >
      <ng-template appXIModalContent>
        @if (showDocumentViewModal) {
          <app-document-view-dialog
            [options]="documentViewModalOptions"
            (modalClosed)="onDocumentViewModalClosed($event)"
          ></app-document-view-dialog>
        }
      </ng-template>
    </app-lex-xi-modal>
  }
  @if (showSmartSummaryModal) {
    <app-lex-xi-modal
      [isVisible]="showSmartSummaryModal"
      [canBackdropClose]="false"
      maxWidth="80vw"
      (close)="onSmartSummaryClosed($event)"
    >
      <ng-template appXIModalContent>
        @if (showSmartSummaryModal) {
          <app-interactive-smart-summary
            [options]="interactiveSmartSummaryOptions"
            (modalClosed)="onSmartSummaryClosed($event)"
            (addComment)="onAddSmartSummaryComment($event)"
            (addNotes)="onAddSmartSummaryNotes($event)"
          ></app-interactive-smart-summary>
        }
      </ng-template>
    </app-lex-xi-modal>
  }
</ng-container>
